// frontend/src/pages/teacherdashboard.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './studentdashboard.css';
import API_BASE_URL from '../quiz_management/config';

function TeacherDashboard() {
    const navigate = useNavigate();
    const [teacher, setTeacher] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('teacherToken');
        const teacherData = localStorage.getItem('teacherData');
        if (token && teacherData) {
            try {
                setTeacher(JSON.parse(teacherData));
            } catch {
                navigate('/teacher/login');
            }
        } else {
            navigate('/teacher/login');
        }
        setLoading(false);
    }, [navigate]);

    const handleLogout = async () => {
        try {
            await fetch(`${API_BASE_URL}/teachers/auth/logout`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${localStorage.getItem('teacherToken')}` }
            });
        } catch (err) {
            // Ignore network errors on logout
        } finally {
            localStorage.removeItem('teacherToken');
            localStorage.removeItem('teacherData');
            navigate('/teacher/login');
        }
    };

    if (loading) return <div className="loading-container">Loading your dashboard...</div>;
    if (!teacher) return null;

    return (
        <div className="student-dashboard">
            <div className="dashboard-header">
                <div className="welcome-section">
                    <h1>Welcome, {teacher.name}! 👨‍🏫</h1>
                    <p>Manage your classroom activities</p>
                </div>
                <div className="user-actions">
                    <span className="user-email">{teacher.email}</span>
                    <button onClick={handleLogout} className="logout-btn">Logout</button>
                </div>
            </div>

            <div className="features-section">
                <h2>Teaching Tools</h2>
                <div className="features-grid">
                    <div className="feature-card" onClick={() => navigate('/teacher/livequiz')}>
                        <div className="feature-icon"><span>🎯</span></div>
                        <div className="feature-content">
                            <h3>Live Quiz</h3>
                            <p>Host a live quiz session — poll, buzzer, or turn-based</p>
                        </div>
                        <div className="feature-arrow">→</div>
                    </div>
                    {/* Future teacher features get added as cards here */}
                </div>
            </div>

            <div className="dashboard-footer">
                <div className="app-info">
                    <h4>Smart AI Tutor</h4>
                    <p>Teacher console</p>
                </div>
            </div>
        </div>
    );
}

export default TeacherDashboard;